import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialElevationDirective } from './material-elevation.directive';
import { ClickOutsideDirective } from './click-outside.directive';
import { PrimaryButtonDirective } from './primaryButton.directive';
import { GhostButtonDirective } from './ghostButton.directive';
import { WhiteButtonDirective } from './whiteButton.directive';
import { SecondaryButtonDirective } from './secondaryButton.directive';
import { SecondaryButtonWithBorderDirective } from './secondaryButtonWithBorder.directive';
import { DangerButtonDirective } from './dangerButton.directive';
import { GhostButtonWithBorderDirective } from './ghostButtonWithBorder.directive';
import { DragAndDropDirective } from './drag-and-drop.directive';

@NgModule({
    imports: [CommonModule],
    declarations: [
        ClickOutsideDirective,
        MaterialElevationDirective,
        PrimaryButtonDirective,
        GhostButtonDirective,
        WhiteButtonDirective,
        SecondaryButtonDirective,
        SecondaryButtonWithBorderDirective,
        DangerButtonDirective,
        GhostButtonWithBorderDirective,
        DragAndDropDirective
    ],
    exports: [
        ClickOutsideDirective,
        MaterialElevationDirective,
        PrimaryButtonDirective,
        GhostButtonDirective,
        WhiteButtonDirective,
        SecondaryButtonDirective,
        SecondaryButtonWithBorderDirective,
        DangerButtonDirective,
        GhostButtonWithBorderDirective
    ],
    providers: []
})
export class SharedDirectiveModule {}
